import { useMutation } from 'react-query';
import { emailMessageRequest } from 'src/models/CRM';
import { postEmailMessage } from 'src/services/CRM/customers';

export default function useSendEmail() {
  return useMutation((data: emailMessageRequest) => postEmailMessage(data), {});
}
